export default "__VITE_ASSET__5e4ab876__"